import type { CardItemBreedQuizResultData, PromoNewsletterData } from '@presentation/components';
import type { MouseEventHandler } from 'react';

export interface QuizResultsPageData {
  answers?: any;
  loading?: boolean;
  items: CardItemBreedQuizResultData[];
  showNewsletterForm?: boolean;
  newsletterForm: PromoNewsletterData;

  onRestartClick?: MouseEventHandler;
  onSubscribeClick(breedName: string): void;
}

export interface QuizResultsPageProps extends QuizResultsPageData {}
